/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  OrganizationSearchResponse,
  SearchOrganizationsParams,
} from './platformapi.schemas';

import searchOrganizationsMutator from '../custom-axios-instance';

/**
 * Search for organizations
 * @summary Search Organizations
 */
export const searchOrganizations = (params?: SearchOrganizationsParams, signal?: AbortSignal) => {
  return searchOrganizationsMutator<OrganizationSearchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/search/organizations/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchOrganizationsQueryKey = (params?: SearchOrganizationsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/search/organizations/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizations>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchOrganizationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOrganizations>>> = ({ signal }) =>
    searchOrganizations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchOrganizations>>
>;
export type SearchOrganizationsQueryError = void | HTTPValidationError;

export function useSearchOrganizations<
  TData = Awaited<ReturnType<typeof searchOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | SearchOrganizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganizations>>,
          TError,
          Awaited<ReturnType<typeof searchOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchOrganizations<
  TData = Awaited<ReturnType<typeof searchOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganizations>>,
          TError,
          Awaited<ReturnType<typeof searchOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchOrganizations<
  TData = Awaited<ReturnType<typeof searchOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search Organizations
 */

export function useSearchOrganizations<
  TData = Awaited<ReturnType<typeof searchOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params?: SearchOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
